import Vue from 'vue'
import { Model } from '@vuex-orm/core'

export default class App extends Model {
    static get entity() {
        return 'apps'
    }
    static of(service = 'ship') {
        this.create({
            data: {
                id: 1,
                width: window.innerWidth,
                height: window.innerHeight,
                lang: window.navigator.language,
                token: '',
                service: service,
                api: process.env.VUE_APP_API_URL + '/ship',
                attend: process.env.VUE_APP_API_URL + '/attend',
                overall: process.env.VUE_APP_API_URL + '/overall',
                ojb: process.env.VUE_APP_OJB_URL,
                attendHome: process.env.VUE_APP_ATTEND_URL,
                loading: false,
                logined: false,
            },
        })
    }
    static setLanguage(v) {
        this.update({
            where: 1,
            data: {
                lang: v,
            },
        })
    }
    static setLogined(v) {
        this.update({
            where: 1,
            data: {
                logined: v,
            },
        })
    }
    static setToken(v) {
        this.update({
            where: 1,
            data: {
                token: v,
            },
        })
    }
    static loadingOn() {
        this.update({
            where: 1,
            data: {
                loading: true,
            },
        })
    }
    static loadingOff() {
        this.update({
            where: 1,
            data: {
                loading: false,
            },
        })
    }
    static acceptLanguage() {
        return this.query().first().lang
    }
    static apiToken() {
        return this.query().first().token
    }
    static apiURL() {
        return this.query().first().api
    }
    static attendURL() {
        return this.query().first().attend
    }
    static overallURL() {
        return this.query().first().overall
    }
    static attendHome() {
        return this.query().first().attendHome
    }
    static currentPage() {
        return this.query().first().page
    }
    static one() {
        return this.query().first()
    }
    static renewalSnackbar() {
        if (Vue.prototype.$buefy) {
            Vue.prototype.$buefy.snackbar.open({
                message: Vue.i18n.t('ship.labor.renewal'),
                position: 'is-bottom',
                duration: 8000, // デフォルト8秒
            });
        }
    }
    static fields() {
        return {
            id: this.attr('1'),
            width: this.attr(0),
            height: this.attr(0),
            lang: this.attr('ja'),
            token: this.attr(''),
            service: this.attr('ship'),
            api: this.attr(''),
            attend: this.attr(''),
            overall: this.attr(''),
            obj: this.attr(''),
            attendHome: this.attr(''),
            loading: this.attr(false),
            logined: this.attr(false),
        }
    }
    static get(params) {
        let data = {}
        let _this = new Vue()
        Object.keys(params).forEach(function (key) {
            if (!key.includes('$')) {
                if (!this[key]) {
                    data[key] = ''
                } else if (
                    Object.prototype.toString.call(this[key]).includes('Date')
                ) {
                    data[key] = _this.$dayjs(this[key]).format()
                } else {
                    data[key] = this[key]
                }
            }
        }, params)
        return data
    }
    static post(params) {
        let data = new FormData()
        let _this = new Vue()
        Object.keys(params).forEach(function (key) {
            if (!key.includes('$')) {
                if (this[key] === 0) {
                    data.append(key, 0)
                } else if (!this[key]) {
                    data.append(key, '')
                } else if (
                    Object.prototype.toString.call(this[key]).includes('Date')
                ) {
                    data.append(key, _this.$dayjs(this[key]).format())
                } else {
                    data.append(key, this[key])
                }
            }
        }, params)
        return data
    }
    static patch(params) {
        let data = new URLSearchParams()
        let _this = new Vue()
        Object.keys(params).forEach(function (key) {
            if (!key.includes('$')) {
                if (this[key] === 0) {
                    data.append(key, 0)
                } else if (!this[key]) {
                    data.append(key, '')
                } else if (
                    Object.prototype.toString.call(this[key]).includes('Date')
                ) {
                    data.append(key, _this.$dayjs(this[key]).format())
                } else {
                    data.append(key, this[key])
                }
            }
        }, params)
        return data
    }
    get language() {
        return this.lang
    }
    get isGuest() {
        return this.logined ? false : true
    }
    get isMember() {
        return this.logined
    }
    get isTouch() {
        return this.width <= 1023 ? true : false
    }
    get isPC() {
        return this.width >= 1024 ? true : false
    }
    get isMobile() {
        return this.width <= 768 ? true : false
    }
    get isTablet() {
        return 769 <= this.width && this.width <= 1023 ? true : false
    }
    get isDesktop() {
        return 1024 <= this.width && this.width <= 1215 ? true : false
    }
    get isWideScreen() {
        return 1216 <= this.width && this.width <= 1407 ? true : false
    }
    get isFullHD() {
        return this.width >= 1408 ? true : false
    }
    get isTouchDevice() {
        return (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
                navigator.userAgent
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                navigator.userAgent.substr(0, 4)
            )
        )
    }
}
